<template>
  <section
    v-copy="null"
    class="travel-quote-info">
    <div class="box">
      <div class="table mg-b-10">
        <div class="tr">
          <span>Insured Period</span>
          <span
            v-copy="formData.insurance_period"
            :class="{'green-tip':handleCompare('insurance_period')}">{{ formData.insurance_period}}</span>
        </div>
        <div class="tr">
          <span>Expected Insured Period</span>
          <span
            v-copy="formData.period_date"
            :class="{'green-tip':handleCompare('period_date')}">
            {{ formData.period_date }}
            <span
              v-if="formData.is_eff_dt_delay && formData.pcy_stts != 425"
              class="asap">(ASAP)</span>
          </span>
        </div>
        <div class="tr">
          <span>Total Payable</span>
          <span
            v-if="showAmount"
            v-copy="amount"
            :class="{'green-tip':isChange}">{{ amount }}</span>
        </div>
        <div class="tr">
          <span>Referrer</span>
          <span
            v-if="referrer"
            class="flex-column">
            <router-link
              :to="{path:'/accounts/detail',query:{customer_id:referrer.id}}"
              class="flex flex-wrap text-decoration-none">
              <span
                class="referrer"
                @click="handlerUser(referrer.id)">
                {{referrer.identity==2?referrer.isrd_com_nm:`${referrer.isrd_lst_nm||''} ${referrer.isrd_fst_nm||''}`}}
              </span>
            </router-link>
            <div class="tags">
              <span
                v-if="referrer.is_tier_base"
                class="span-status blue">
                Professional
              </span>
              <span
                v-if="referrer.verify_language"
                class="span-status"
                :class="{
                  'verified': referrer.verified == 20,
                  'pending_verify ': referrer.verified == -1,
                  'not_verify': referrer.verified == -2
                }">
                {{ referrer.verify_language }}
              </span>
              <span
                v-if="referrer.is_flagged"
                class="span-status flag">
                Flagged
              </span>
            </div>
          </span>
        </div>
        <!--        <div-->
        <!--          v-if="formData.discount_str"-->
        <!--          class="tr">-->
        <!--          <span>Referrer Discount</span>-->
        <!--          <span>{{formData.discount_str}}</span>-->
        <!--        </div>-->
        <div
          v-if="!isEndorse"
          class="tr">
          <span>Policy Number </span>
          <span
            v-copy="formData.pcy_no"
            :class="{'green-tip':handleCompare('pcy_no')}">{{ formData.pcy_no  }}</span>
        </div>
        <div
          v-else
          class="tr">
          <span>Endorsement Number </span>
          <span
            v-copy="formData.endorser_no"
            :class="{'green-tip':handleCompare('endorser_no')}">{{ formData.endorser_no  }}</span>
        </div>
        <div class="tr">
          <span>Policy Reference Code </span>
          <span
            v-copy="formData.order_sn"
            :class="{'green-tip':handleCompare('order_sn')}">{{ formData.order_sn }}</span>
        </div>
      </div>
    </div>
    <div
      v-if="excessList.length"
      class="box">
      <h3>Excess</h3>
      <div class="table">
        <div class="tr th">
          <span>Item</span>
          <span>Amount</span>
        </div>
        <div
          v-for="(inItem, index) in excessList"
          :key="index + inItem.premium"
          class="tr">
          <span>{{ inItem.item }}</span>
          <span v-copy="inItem.premium">{{ inItem.premium }}</span>
        </div>
        <div class="tr">
          <span>Excess Remark</span>
          <span
            :class="{'green-tip':handleCompare('quote_remark')}"
            v-html="changeLineData(formData.quote_remark)"></span>
        </div>
      </div>
    </div>
    <div class="box">
      <div
        v-for="(excessItem, excessIndex) in coverageList.items"
        :key="'coverage' + excessIndex">
        <div
          v-if="excessItem.sub_items.length>0"
          class="table">
          <h3 :class="{'table-title':excessIndex>0}">{{ excessItem.sub_title? excessItem.sub_title: coverageList.title }}</h3>
          <div
            v-if="excessIndex==0"
            class="tr th">
            <span>Item</span>
            <span>Information</span>
          </div>
          <div
            v-for="(subItem, subIndex) in excessItem.sub_items"
            :key="'coverage-' + excessIndex + subIndex"
            class="tr">
            <span>{{ subItem.item }}</span>
            <span
              v-copy="subItem.premium"
            >{{ subItem.premium }}</span>
          </div>
          <div class="tr">
            <span>Coverage Remark</span>
            <span
              v-copy="changeLineData(formData.cvr_remark)"
              :class="{'green-tip':handleCompare('quote_remark')}"
              v-html="changeLineData(formData.cvr_remark)"></span>
          </div>
        </div>
      </div>
    </div>
    <!--    <div class="box">-->
    <h2>Policy Detail</h2>
    <!--      <div class="table mg-b-10">-->
    <!--        <div class="tr">-->
    <!--          <span>Expected  Effective Date</span>-->
    <!--          <span-->
    <!--            v-copy="formData.pcy_cmnt_date "-->
    <!--            :class="{'green-tip':handleCompare('pcy_cmnt_date')}">{{ formData.pcy_cmnt_date }}</span>-->
    <!--        </div>-->
    <!--        <div class="tr">-->
    <!--          <span>Expected  Expiry Date</span>-->
    <!--          <span-->
    <!--            v-copy="formData.pcy_expry_date"-->
    <!--            :class="{'green-tip':handleCompare('pcy_expry_date')}">{{ formData.pcy_expry_date }}</span>-->
    <!--        </div>-->
    <!--        <div-->
    <!--          v-if="option_benefits.length>0"-->
    <!--          class="tr">-->
    <!--          <span>Optional Benefits</span>-->
    <!--          <span>-->
    <!--            <span-->
    <!--              v-for="(item,index) in option_benefits"-->
    <!--              :key="'extra'+index"-->
    <!--              v-copy="item.item"-->
    <!--            >{{item.item}}<br></span>-->
    <!--          </span>-->
    <!--        </div>-->
    <!--      </div>-->
    <personal-quote-info
      :formData="formData"
      :preFormData="preFormData"
      :compareList="compareList"></personal-quote-info>
    <!--    </div>-->

    <!--    <div class="box">-->
    <!--      <h2>Policyholder Detail</h2>-->
    <!--      <div class="table">-->
    <!--        <div class="tr">-->
    <!--          <span>Title</span>-->
    <!--          <span-->
    <!--            v-copy="getOptionName('titleOptions', formData.isrd_title) "-->
    <!--            :class="{'green-tip':handleCompare('isrd_title')}">{{ getOptionName('titleOptions', formData.isrd_title) }}</span>-->
    <!--        </div>-->
    <!--        <div class="tr">-->
    <!--          <span>Last Name</span>-->
    <!--          <span-->
    <!--            v-copy="formData.isrd_lst_nm"-->
    <!--            :class="{'green-tip':handleCompare('isrd_lst_nm')}">{{ formData.isrd_lst_nm }}</span>-->
    <!--        </div>-->
    <!--        <div class="tr">-->
    <!--          <span>First Name</span>-->
    <!--          <span-->
    <!--            v-copy="formData.isrd_fst_nm"-->
    <!--            :class="{'green-tip':handleCompare('isrd_fst_nm')}">{{ formData.isrd_fst_nm }}</span>-->
    <!--        </div>-->
    <!--        <div class="tr">-->
    <!--          <span>Date of Birth</span>-->
    <!--          <span-->
    <!--            v-copy="formData.isrd_dob_date"-->
    <!--            :class="{'green-tip':handleCompare('isrd_dob_date')}">{{ formData.isrd_dob_date }}</span>-->
    <!--        </div>-->
    <!--        <div class="tr">-->
    <!--          <span>Mobile Number</span>-->
    <!--          <span-->
    <!--            v-copy="formData.mobile_no"-->
    <!--            :class="{'green-tip':handleCompare('mobile_no')}">{{ formData.mobile_no }}</span>-->
    <!--        </div>-->
    <!--        <div class="tr">-->
    <!--          <span>HKID Number</span>-->
    <!--          <span-->
    <!--            v-copy="formData.id_no"-->
    <!--            :class="{'green-tip':handleCompare('id_no')}">{{ formData.id_no }}</span>-->
    <!--        </div>-->
    <!--        <div class="tr">-->
    <!--          <span>Email</span>-->
    <!--          <span-->
    <!--            v-copy="formData.email"-->
    <!--            :class="{'green-tip':handleCompare('email')}">-->
    <!--            {{ formData.email }}-->
    <!--            <email-tooltip :email="formData.email"></email-tooltip>-->
    <!--          </span>-->
    <!--        </div>-->
    <!--        <div class="tr">-->
    <!--          <span>Occupation</span>-->
    <!--          <span-->
    <!--            v-copy="formData.occ"-->
    <!--            :class="{'green-tip':handleCompare('occ')}">{{ formData.occ }}</span>-->
    <!--        </div>-->
    <!--        <div-->
    <!--          v-if="isShowEmployer"-->
    <!--          class="tr">-->
    <!--          <span>Name of Employer</span>-->
    <!--          <span-->
    <!--            v-copy="formData.employer_nm"-->
    <!--            :class="{'green-tip':handleCompare('employer_nm')}">{{ formData.employer_nm }}</span>-->
    <!--        </div>-->
    <!--        <div-->
    <!--          v-if="isShowEmployer"-->
    <!--          class="tr">-->
    <!--          <span>Nature of Business</span>-->
    <!--          <span-->
    <!--            v-copy="getAllOptionName27('industry',formData.employer_bsns_nature_id)"-->
    <!--            :class="{'green-tip':handleCompare('employer_bsns_nature_id')}">{{ getAllOptionName27('industry',formData.employer_bsns_nature_id) }}</span>-->
    <!--        </div>-->
    <!--        <div class="tr">-->
    <!--          <span>Handedness</span>-->
    <!--          <span-->
    <!--            v-copy="getAllOptionName27('handedness',formData.handedness_id)"-->
    <!--            :class="{'green-tip':handleCompare('handedness_id')}">{{ getAllOptionName27('handedness',formData.handedness_id) }}</span>-->
    <!--        </div>-->
    <!--      </div>-->
    <!--      <h3>Correspondence Address</h3>-->
    <!--      <div class="table">-->
    <!--        <div class="tr">-->
    <!--          <span>Room</span>-->
    <!--          <span-->
    <!--            v-copy="formData.addr_room"-->
    <!--            :class="{'green-tip':handleCompare('addr_room')}">{{ formData.addr_room }}</span>-->
    <!--        </div>-->
    <!--        <div class="tr">-->
    <!--          <span>Floor</span>-->
    <!--          <span-->
    <!--            v-copy="formData.addr_floor"-->
    <!--            :class="{'green-tip':handleCompare('addr_floor')}">{{ formData.addr_floor }}</span>-->
    <!--        </div>-->
    <!--        <div class="tr">-->
    <!--          <span>Block</span>-->
    <!--          <span-->
    <!--            v-copy="formData.addr_block"-->
    <!--            :class="{'green-tip':handleCompare('addr_block')}">{{ formData.addr_block }}</span>-->
    <!--        </div>-->
    <!--        <div class="tr">-->
    <!--          <span>Building / Estate</span>-->
    <!--          <span :class="{'green-tip':handleCompare('addr_building')}">{{ formData.addr_building }}</span>-->
    <!--        </div>-->
    <!--        <div class="tr">-->
    <!--          <span>Street</span>-->
    <!--          <span-->
    <!--            v-copy="formData.addr_street"-->
    <!--            :class="{'green-tip':handleCompare('addr_street')}">{{ formData.addr_street }}</span>-->
    <!--        </div>-->
    <!--        <div class="tr">-->
    <!--          <span>District</span>-->
    <!--          <span-->
    <!--            v-copy="getAreaName('district', formData.addr_district)"-->
    <!--            :class="{'green-tip':handleCompare('addr_district')}">{{ getAreaName('district', formData.addr_district) }}</span>-->
    <!--        </div>-->
    <!--        <div class="tr">-->
    <!--          <span>Area</span>-->
    <!--          <span-->
    <!--            v-copy="getAreaName('area', formData.addr_area)"-->
    <!--            :class="{'green-tip':handleCompare('addr_area')}">{{ getAreaName('area', formData.addr_area) }}</span>-->
    <!--        </div>-->
    <!--        <div class="tr">-->
    <!--          <span>Country / Region</span>-->
    <!--          <span-->
    <!--            v-copy="getAreaName('region', formData.addr_region)"-->
    <!--            :class="{'green-tip':handleCompare('addr_region')}">{{ getAreaName('region', formData.addr_region) }}</span>-->
    <!--        </div>-->

    <!--      </div>-->
    <!--      <h3  v-if="isShowEmployer">Office Address</h3>-->
    <!--      <div-->
    <!--        v-if="isShowEmployer"-->
    <!--        class="table">-->
    <!--        <div class="tr">-->
    <!--          <span>Room</span>-->
    <!--          <span-->
    <!--            v-copy="formData.office_addr_room"-->
    <!--            :class="{'green-tip':handleCompare('office_addr_room')}">{{ formData.office_addr_room }}</span>-->
    <!--        </div>-->
    <!--        <div class="tr">-->
    <!--          <span>Floor</span>-->
    <!--          <span-->
    <!--            v-copy="formData.office_addr_floor"-->
    <!--            :class="{'green-tip':handleCompare('office_addr_floor')}">{{ formData.office_addr_floor }}</span>-->
    <!--        </div>-->
    <!--        <div class="tr">-->
    <!--          <span>Block</span>-->
    <!--          <span-->
    <!--            v-copy="formData.office_addr_block"-->
    <!--            :class="{'green-tip':handleCompare('office_addr_block')}">{{ formData.office_addr_block }}</span>-->
    <!--        </div>-->
    <!--        <div class="tr">-->
    <!--          <span>Building / Estate</span>-->
    <!--          <span :class="{'green-tip':handleCompare('office_addr_building')}">{{ formData.office_addr_building }}</span>-->
    <!--        </div>-->
    <!--        <div class="tr">-->
    <!--          <span>Street</span>-->
    <!--          <span-->
    <!--            v-copy="formData.office_addr_street"-->
    <!--            :class="{'green-tip':handleCompare('office_addr_street')}">{{ formData.office_addr_street }}</span>-->
    <!--        </div>-->
    <!--        <div class="tr">-->
    <!--          <span>District</span>-->
    <!--          <span-->
    <!--            v-copy="getAreaName('district', formData.office_addr_district)"-->
    <!--            :class="{'green-tip':handleCompare('employer_addr_district')}">{{ getAreaName('district', formData.office_addr_district) }}</span>-->
    <!--        </div>-->
    <!--        <div class="tr">-->
    <!--          <span>Area</span>-->
    <!--          <span-->
    <!--            v-copy="getAreaName('area', formData.office_addr_area)"-->
    <!--            :class="{'green-tip':handleCompare('office_addr_area')}">{{ getAreaName('area', formData.office_addr_area) }}</span>-->
    <!--        </div>-->
    <!--        <div class="tr">-->
    <!--          <span>Country / Region</span>-->
    <!--          <span-->
    <!--            v-copy="getAreaName('region', formData.office_addr_region)"-->
    <!--            :class="{'green-tip':handleCompare('office_addr_region')}">{{ getAreaName('region', formData.office_addr_region) }}</span>-->
    <!--        </div>-->

    <!--      </div>-->
    <!--    </div>-->

    <div class="box">
      <h3>Remark(s)</h3>
      <div class="table">
        <div class="tr">
          <span>Remark</span>
          <span
            v-copy="changeLineData(formData.cs_manual_remark)"
            :class="{'green-tip':handleCompare('cs_manual_remark')}"
            v-html="changeLineData(formData.cs_manual_remark)"></span>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import dayjs from 'dayjs'
import MixinOptions from '@/mixins/options'
import MixinFormat from '@/mixins/format'
import {mapState} from 'vuex'
import OMath from '@/utils/math'
import PersonalQuoteInfo from '@/views/components/modules/personal/personal-quote-info'

export default {
  name: 'PersonalPolicyDetailInfo',
  components: {PersonalQuoteInfo},
  mixins: [MixinOptions, MixinFormat],
  props: {
    formData: {
      type: Object,
      default: () => ({})
    },
    preFormData: {
      type: Object,
      default: () => ({})
    },
    showAmount: {
      type: [String,Number],
      default: ''
    },
    isChange: {
      type: Boolean,
      default: false
    },
  },
  computed: {
    ...mapState('common', ['nationalityOptions']),
    isShowEmployer(){
      let {occ_id} = this.formData||{}
      return ![220,246].includes(occ_id)
    },
    amount(){
      return  OMath.formatMoney(this.showAmount, 2,true)
    },
    referrer(){
      let {referrer} = this.formData||{}
      return referrer||{}
    },
    sidebarPremium() {
      let {quote_coverage_list={}} =this.formData||{}
      if(!quote_coverage_list) {
        return []
      }
      let { sidebar_premium=[]} =quote_coverage_list||{}
      if(sidebar_premium.length<=0)return  []
      return sidebar_premium
    },
    option_benefits(){
      let {quote_coverage_list={}} = this.formData||{}
      let {more_benefit={}} = quote_coverage_list||{}
      let {sub_items={}} = more_benefit||{}
      let arr =[]
      if(sub_items){
        arr = Object.entries(sub_items).map(item=>item[1])
      }
      return arr
    },
    pcy_end_dt() {
      const { period_of_cvr, pcy_cmnt_dt } = this.formData
      if(pcy_cmnt_dt && period_of_cvr) {
        if(period_of_cvr >= 1) {
          return dayjs(pcy_cmnt_dt).add(period_of_cvr, 'years').format('YYYY-MM-DD')
        }
        else {
          return dayjs(pcy_cmnt_dt).add(Number(period_of_cvr)*10, 'months').format('YYYY-MM-DD')
        }
        // return dayjs(pcy_cmnt_dt).add(period_of_cvr, 'years').format('YYYY-MM-DD')
      }
      return ''
    },
    localAllOptions() {
      return this.allOptions27
    },
    showEndorsementPremium() {
      const {type} = this.formData
      return [30, 40, 50].includes(type)
    },
    isEndorse(){
      return [30,40].includes(this.formData.type)
    },
    excessList(){
      let {quote_coverage_list} = this.formData||{}
      let {excess} = quote_coverage_list||{}
      let {items} = excess||{}
      if(items){
        return items[0].sub_items
      }
      return  []
    },
    coverageList(){
      let {quote_coverage_list} = this.formData||{}
      let {coverage} = quote_coverage_list||{}
      return  coverage
    },
    compareList(){
      let {type} = this.formData||{}
      let nowData = this.formData||{}
      let pre = this.preFormData||{}
      if(type!=50)return []
      let arr =  Object.keys(nowData).reduce((result,key)=>{
        if(nowData[key]!=pre[key]){
          result.push(key)
        }
        return result
      },[])
      return arr||[]
    }
  },
  methods:{
    handleCompare(filed){
      let {type} = this.formData
      if(type!=50) return false
      return  this.compareList.includes(filed)?true:false
    },
  }
}
</script>
<style lang="scss" scoped>
  .housemaid-quote-info{
    .box {
      margin-bottom: 15px;
    }
    .title {
      display: block;
      padding-bottom: 15px;
      font-size: 16px;
      font-weight: 400;
      color: #616266;
    }
    .table-title {
      display: inline-block;
      padding-bottom: 2px;
      padding-left: 5px;
      font-size: 12px;
      font-weight: bold;
      color: #909399;
      line-height: 15px;
    }
  }
  .asap{
    font-weight: bold;
    color: black;
    margin-left: 5px;
  }
</style>
